import React, { useState } from "react";
import { Button } from "@/components/ui/button";
import SipCalculatorDialog from "@/components/SipCalculatorDialog";
import { formatDate, formatINR } from "@/lib/constants";
import { Repeater } from "./_shared";

export default function GoalsTab({ client, onSave, canEdit }) {
  const [goals, setGoals] = useState(client.goals || []);
  const [sipGoal, setSipGoal] = useState(null);
  const save = () => onSave({ goals });
  return (
    <div className="space-y-6">
      <Repeater
        title="Life goals"
        items={goals}
        setItems={setGoals}
        template={() => ({ id: crypto.randomUUID(), title: "", target_amount: 0, target_date: "", priority: "Medium" })}
        columns={[
          ["title", "Goal", "text"],
          ["target_amount", "Amount (₹)", "number"],
          ["target_date", "Target date", "date"],
          ["priority", "Priority", "text"],
        ]}
        canEdit={canEdit}
        keyName="goal"
      />
      {goals.length > 0 && (
        <div className="mt-2 space-y-2">
          <div className="overline text-muted-foreground">SIP calculator</div>
          {goals.filter((g) => g.title && g.target_amount && g.target_date).map((g) => (
            <div key={g.id} className="flex items-center justify-between rounded-md border border-border p-3 text-sm" data-testid={`goal-sip-row-${g.id}`}>
              <div>
                <div className="font-medium">{g.title}</div>
                <div className="text-xs text-muted-foreground">{formatINR(g.target_amount)} by {formatDate(g.target_date)}</div>
              </div>
              <Button size="sm" variant="outline" onClick={() => setSipGoal(g)} data-testid={`calc-sip-${g.id}`}>Calculate SIP</Button>
            </div>
          ))}
        </div>
      )}
      {canEdit && <Button onClick={save} data-testid="save-goals-btn">Save goals</Button>}
      <SipCalculatorDialog goal={sipGoal} open={!!sipGoal} onClose={() => setSipGoal(null)} />
    </div>
  );
}
